<template>
    <div class="row py-7 pr-5 pl-2">
        <div class="col-lg-4">
            <div class="d-flex flex-row">
                <user-initials :name="user.name"/>
                <div class="ml-3">
                    <div class="text-xl font-weight-bold mb-n1">
                        {{ user.name }}
                    </div>
                    <div class="text-lg">
                        <a class="text-dark" :href="`mailto:${user.email}`">{{ user.email }}</a>
                    </div>
                    <div class="text-lg">
                        <a class="text-dark" :href="`tel:${user.phone}`">{{ user.phone }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-8 d-flex flex-row pr-0 mt-5 mt-lg-0">
            <div class="flex-grow-1">
                <div>
                    <div v-for="store in user.stores" class="row">
                        <div class="col-md-5 col-12 text-truncate font-weight-bold">{{ store.attributes.name }}</div>
                        <div class="col-md-5 col-12 text-truncate">{{ address(store) }}</div>
                        <div class="col-md-2 col-12 text-md-right font-weight-bold">{{ store.total.toFixed(2) }}€</div>
                    </div>
                </div>
                <div class="mt-2 border-top pt-2 text-primary text-md-right font-weight-bolder text-uppercase">
                    <div class="text-xl">
                        Gesamt {{ user.total.toFixed(2) }}€
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column justify-content-end justify-content-lg-center ml-5 px-2 px-lg-5">
                <a class="btn btn-icon btn-primary btn-circle" :href="$route('reports.sales.user', {user: user.firebase_uid, start: start, end: end})">
                    <i class="fas fa-chevron-right" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import UserInitials from './UserInitials'

export default {
    components: {
        UserInitials,
    },

    props: {
        start: Date,
        end: Date,
        user: {
            type: Object,
            default: {
                name: '',
                email: '',
                phone: '',
                stores: [],
            },
        },
    },

    methods: {
        address(store) {
            let address = store.attributes.address
            return `${address.street1}, ${address.postcode} ${address.city}`
        },
    },
}
</script>
